import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../../shared/services/auth.service';
import {FilterService} from '../../../../shared/services/filter.service';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {StoreRootState} from '../../../../shared/ngrx/reducers';
import {delay, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {CountedAndPaginated} from '../../../../shared/interface/response/counted-and-paginated';
import {getCurrentRouteState} from '../../../../shared/ngrx/selector';
import {RouterStateUrl} from '../../../../shared/ngrx/route-serializer';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../../shared/components/job-result-dialog/job-result-dialog.component';
import {HttpErrorResponse} from '@angular/common/http';
import {CommissionImportRow} from '../../../../shared/interface/commission-import-row';
import {CommissionImportRowService} from '../../../../shared/services/commission-import-row.service';
import {InsuranceCompany} from '../../../../shared/interface/insurance-company';
import {Sort} from '@angular/material/sort';
import moment from "moment/moment";
import {ReportCustomComponent} from "../../../report-custom/report-custom.component";
import {
  COMMISSION_IMPORT_ROW_STATUS_ASSIGNED, RATE_THRESHOLD_10, RATE_THRESHOLD_40,
  REPORT_TYPE_COMMISSIONS,
  REPORT_TYPE_REGISTRATION
} from "../../../../shared/services/dict.service";

@Component({
  selector: 'app-all-commissions-list',
  templateUrl: './all-commissions-list.component.html',
  styleUrls: ['./all-commissions-list.component.scss']
})
export class AllCommissionsListComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() commissionRedirection: string = null;
  @Input() commissionSettlement: string = null;
  @Input() commissionUpdatePackageId: number = null;
  @Input() contract: string = null;
  @Input() embeddedView = false;
  @Input() enableFilters?: string[] = null;
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  readonly COMMISSION_IMPORT_ROW_STATUS_ASSIGNED = COMMISSION_IMPORT_ROW_STATUS_ASSIGNED;

  initialFilters: any;
  rows: CommissionImportRow[] = [];
  displayedColumns: string[] = [
    'billingMonthImport', 'billingMonthSettlement', 'insuranceCompany', 'contract', 'ofwca', 'policyNumber', 'collection', 'rate', 'commission',
    'internalRisk', 'partner', 'statusChange', 'status',
  ];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  selectedInsuranceCompanies: InsuranceCompany[] = [];
  sortBy = 'createdAt';
  sortOrder = 'desc';
  loadingData = true;
  readonly RATE_THRESHOLD_40 = RATE_THRESHOLD_40;
  readonly RATE_THRESHOLD_10 = RATE_THRESHOLD_10;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private commissionImportRowService: CommissionImportRowService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.commissionImportRowService.rowListSubject
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      ).subscribe({
      next: (response: CountedAndPaginated<CommissionImportRow>) => {
        this.loadingData = false;
        this.rows = response.items;
        this.totalData = response.pagination.total;
      },
      error: (response: HttpErrorResponse) => {
        this.snack.open('Przy ładowaniu danych wystąpił błąd', response.status.toString(), {duration: 2000});
        this.loadingData = false;
      }
    });

    this.parseFilters();
    //
    // const date = moment();
    // date.startOf('month');
    // date.subtract(1, 'month');
    //
    // this.initialFilters.billingMonth = date;
    // this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
    //   billingMonth: this.initialFilters.billingMonth,
    //   ...this.initialFilters,
    // })]);

  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      in$insuranceCompany: 'int[]',
      containsFromLeft$policyNumber: 'string',
      company: 'int',
      ofwca: 'string',
      partner: 'string',
      gte$collection: 'string',
      lte$collection: 'string',
      partnerAssetsRegional: 'string',
      ofwcaAssetsRegional: 'string',
      notMatched: 'string[]',
      matched: 'string[]',
      contract: 'string',
      importer: 'int[]',
      gte$createdAt: 'string',
      lte$createdAt: 'string',
      risk: 'int',
      in$status: 'int[]',
      billingMonth: 'date',
      billingMonthSettlement: 'date',
      edition: 'int',
      contractOwner: 'int',
      contains$customerName: 'string',
      gte$commission: 'int',
      lte$commission: 'int',
      gte$commissionPaid: 'int',
      lte$commissionPaid: 'int',
      gte$rate: 'int',
      lte$rate: 'int',
      gte$ratePaid: 'int',
      lte$ratePaid: 'int',
      overcommissionPartner: 'string',
    }, filters);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.loadingData = true;
      if (this.embeddedView) {
        this.loadListData();
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          ...this.filtersForm.value
        })]);
      }
    });

    if (!this.embeddedView) {
      this.store
        .pipe(
          select(getCurrentRouteState),
          delay(0),
          distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
          takeUntil(this.destroyed$),
        )
        .subscribe((state: RouterStateUrl) => {
          this.parseFilters(state.params);
          this.paginator.pageIndex = state.params.page;
          this.paginator.pageSize = state.params.pageSize;
          this.sortBy = state.params?.sortBy ? state.params.sortBy : 'createdAt';
          this.sortOrder = state.params?.sortOrder ? state.params.sortOrder : 'desc';
          this.loadListData();
        })
      ;
    } else {
      this.loadListData();
    }
  }

  sortChanged($event: Sort): void {
    this.sortBy = $event.active;
    this.sortOrder = $event.direction;

    if (!this.embeddedView) {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        sortBy: $event.active,
        sortOrder: $event.direction,
        page: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value
      })]);
    } else {
      this.loadListData();
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.commissionRedirection) {
      filters.commissionRedirection = this.commissionRedirection;
    }

    if (null !== this.commissionSettlement) {
      filters.settlement = this.commissionSettlement;
    }

    if (null !== this.contract) {
      filters.contract = this.contract;
    }

    if (null !== this.commissionUpdatePackageId) {
      filters.commissionUpdatePackage = this.commissionUpdatePackageId;
    }

    return filters;
  }

  loadListData(): void {
    this.loadingData = true;
    this.commissionImportRowService.loadList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters(),
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      });
  }

  filter(): void {
    if (this.loadingData) {
      return;
    }

    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        ...this.filtersForm.value,
      })]);
    }
  }

  downloadReport(): void {
    this.commissionImportRowService.downloadReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: this.paginator.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
      }]);
    }
  }

  openReportDialog(): void {
    const dialogRef = this.dialog.open(ReportCustomComponent, {
      width: '70%',
      data: {
        filter: this.filtersForm,
        reportName: REPORT_TYPE_COMMISSIONS
      },
    });
  }

  removeThresholds(manuallySet: string[]): string[] {
    return manuallySet.filter(
      (item) => item !== RATE_THRESHOLD_40 && item !== RATE_THRESHOLD_10
    );
  }

  showMassEditChips(manuallySet: string[]): boolean {
    const filteredSet = this.removeThresholds(manuallySet);
    return filteredSet.length > 0;
  }
}
